import type { PickListDesignTokens } from '@primeuix/themes/types/picklist'

export default {
  root: {
    gap: '1.125rem',
  },
  controls: {
    gap: '0.5rem',
  },
} satisfies PickListDesignTokens
